import { render, staticRenderFns } from "./MainAdminHeader.vue?vue&type=template&id=d616824a&scoped=true&"
import script from "./MainAdminHeader.vue?vue&type=script&lang=js&"
export * from "./MainAdminHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainAdminHeader.vue?vue&type=style&index=0&id=d616824a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d616824a",
  null
  
)

export default component.exports